import React, { useEffect, useRef, useState } from 'react';

const Loader = ({closeLoader}) => {

    const [loading, setLoading] = useState(true);

    const image = useRef();
    const title = useRef();

    let hue = 0;
    let direction = 1;

    useEffect(() => {
        let timeout = setTimeout(() => {
            setLoading(false);
        }, 3500)

        let timeout2 = setTimeout(() => {
            closeLoader();
        }, 4000)

        let chrono = setInterval(() => {
            hue += 90 * direction;
            
            if (hue >= 300 || hue <= 0) {
                direction *= -1;
            }
            
            image.current.style.filter = `hue-rotate(${hue}deg)`;
            title.current.style.filter = `hue-rotate(${hue}deg)`;
        }, 750);

        return () => {
            clearTimeout(timeout);
            clearTimeout(timeout2);
            clearInterval(chrono);
        };
    }, [])

    return (
        <div className={loading ? 'loader visible' : 'loader'}>
            <img src="./assets/images/totodile.webp" alt="Un Kaiminus shiny de toutes les couleurs" ref={image} />
            <h1 ref={title}>Chromatodile</h1>
        </div>
    );
};

export default Loader;